import { api } from "../api/api";
import { InferActionsTypes, AppStateType } from "../reducers/store";
import { ThunkAction } from "redux-thunk";
import { IEduMenu } from "../entities/Menu";

const actionPre = "EDU_";

export const SET_MENU = actionPre + "SET_MENU";
export const TOGGLE_IS_DATA_FETCHING = actionPre + "TOGGLE_IS_DATA_FETCHING";

type ActionsTypes = InferActionsTypes<typeof educationActions>;
type ThunkType = ThunkAction<
  Promise<void>,
  AppStateType,
  unknown,
  ActionsTypes
>;

export const educationActions = {
  setMenu: (menu: IEduMenu[]) => ({ type: SET_MENU, menu }),
  toggleIsDataFetching: (isFetching: boolean) => ({
    type: TOGGLE_IS_DATA_FETCHING,
    isFetching,
  }),
};

export const requestMenu = (): ThunkType => async (dispatch, getState) => {
  dispatch(educationActions.toggleIsDataFetching(true));
  const response = await api.getMenu("admin", null);

  dispatch(educationActions.setMenu(response));
  dispatch(educationActions.toggleIsDataFetching(false));
};

export const requestAnyTraderShopsSuppliers = (tbl: string, json: any) => {
  return api.requestAnyTraderShopsSuppliers(tbl, json);
};

export const requestCheckPromo = (tbl: string, json: any) => {
  return api.requestCheckPromo(tbl, json);
};

export const getAdmin = (table: string, action: string) => {
  return api.getAdmin(table, action);
};
